import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'
import { toast } from 'react-toastify'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import { findKeyFromArrayByValue, formatDate, formatMoney, formatMoneyInput, returnSign } from 'helpers/helpers'
import { GET, POST, PUT, httpOk } from 'helpers/api'
import { COLUMN_LOCK_CATALOG } from 'config/columnLocks'
import { exportMenu } from 'containers/layout/owner/menu'

// Bo'limlarni menyudagi guruhlar bo'yicha tartiblaymiz (Hujjatlar, Hisobotlar, Ombor, Analitika...).
// Guruhlar menu.js dagi `title` sarlavhalaridan olinadi — o'zboshimcha emas, menyu bilan bir xil.
const SECTION_GROUPS = (() => {
	const groups = []
	let current = null
	exportMenu.forEach((block) => {
		(block.children || []).forEach((item) => {
			if (item.title) {
				current = { i18n: item.i18n, perms: [] }
				groups.push(current)
			} else if (item.permission && current) {
				current.perms.push(item.permission)
			}
		})
	})
	return groups
})()

function Index() {
	const { t } = useTranslation()

	const statuses = [
		{ 'id': 1, 'name': "Активный" },
		{ 'id': -1, 'name': "Отключен" },
		{ 'id': -2, 'name': "Удален" },
	]

	const paymentStatuses = [
		{ 'id': 1, 'name': "Оплата" },
		{ 'id': -1, 'name': "Минус баланс" },
	]

	const [data, setData] = useState([])
	const [users, setUsers] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [payments, setPayments] = useState([])
	const [posPaymentTypes, setPosPaymentTypes] = useState([])
	const [tariffPlans, setTariffPlans] = useState([])
	const [sectionsModal, setSectionsModal] = useState({ show: false, posId: null, title: '', rows: [] })
	const [columnsModal, setColumnsModal] = useState({ show: false, posId: null, title: '', locked: [] })
	const [tariffModal, setTariffModal] = useState({ show: false, tariffId: null, rows: [] })
	const [modalUpdate, setModalUpdate] = useState(false)
	const [modalPayment, setModalPayment] = useState(false)
	const [modalInvoice, setModalInvoice] = useState(false)
	const [modalInfo, setModalInfo] = useState(false)
	const [modalStatus, setModalStatus] = useState(false)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({ status: 1 })
	const [pagination, setPagination] = useState({
		url: '/admin/pos',
		response: null
	})

	async function searchWithFilter() {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/admin/pos"
		var urlParams = ""
		checkFilter()

		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page
		if (filterDataCopy.size)
			urlParams += returnSign(urlParams) + 'size=' + filterDataCopy.size

		if (`/admin/pos${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	async function createUpdate(e) {
		e.preventDefault();

		var response
		if (!selectedItem.id) {
			response = await POST('/admin/pos', selectedItem, { loader: true })
		} else {
			response = await PUT('/admin/pos', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			setSelectedItem({})
			setModalUpdate(false)
			searchWithFilter()
		}
	}

	async function payment(e) {
		e.preventDefault();

		var response = await POST('/admin/pos-payment', selectedItem, { loader: true })
		if (httpOk(response)) {
			setSelectedItem({})
			setModalPayment(false)
			searchWithFilter()
		}
	}

	async function createInvoice(e) {
		e.preventDefault();

		var sendData = {}

		sendData.id = selectedItem.id
		sendData.pos_payment_type_id = 1
		sendData.amount = selectedItem.amount
		sendData.phone = `998${selectedItem.invoice_phone}`

		const response = await POST('/payment/pos-invoice', sendData)
		if (httpOk(response)) setModalInvoice(false)
	}

	function toggleModalUpdate(item) {
		var selectedItemCopy = { ...item }
		setSelectedItem(selectedItemCopy)
		setModalUpdate(true)
	}

	function toggleModalPayment(item) {
		if (!posPaymentTypes.length) getPosPaymentTypes()

		var selectedItemCopy = { ...item }
		selectedItemCopy.payment = ""
		selectedItemCopy.note = ""
		selectedItemCopy.status = 1
		selectedItemCopy.to_pos_id = ''
		selectedItemCopy.amount = item.tariff
		setSelectedItem(selectedItemCopy)
		setModalPayment(true)
	}

	function toggleModalInvoice(item) {

		var selectedItemCopy = { ...item }
		if (item.balance <= 0) {
			selectedItemCopy.amount = Math.abs(item.balance)
		} else {
			selectedItemCopy.amount = item.tariff
		}
		selectedItemCopy.invoice_phone = ""

		setSelectedItem(selectedItemCopy)
		setModalInvoice(true)
	}

	async function toggleModalInfo(item) {
		const response = await GET('/admin/pos-payment-detail', {
			'login': item.login,
			'id': item.id,

		}, { loader: true })

		if (httpOk(response)) {
			setPayments(response.data)
			setModalInfo(true)
		}
	}

	async function handleChangeStatus(e) {
		e.preventDefault()

		await PUT('/admin/pos/change-status', selectedItem, { loader: true })
		searchWithFilter()
		toggleModalStatus(false)
	}

	async function toggleModalStatus(bool, item = {}) {
		if (bool) {
			setSelectedItem(item)
			setModalStatus(true)
		} else {
			setModalStatus(false)
		}
	}

	async function toggleModalCreateUpdate(bool, item = {}) {
		if (!users.length) getUsers()
		if (!item.id) item.type = 1
		setSelectedItem(item)
		setModalUpdate(bool)
	}

	function resetFilter() {
		setFilterData({
			status: null,
		})
		searchWithFilter()
	}

	function checkFilter() {
		if (filterData.status === null) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	function returnClassStatus(status) {
		if (status === 1) {
			return "bg-primary"
		}
		if (status === -1) {
			return "bg-danger"
		}
		if (status === -2) {
			return "bg-secondary"
		}
		if (status === -3) {
			return "bg-danger"
		}
	}

	// Tarif rejalari (Start/Pro/Full) va biznesga biriktirish
	// ===== Bo'limlarni galochka bilan boshqarish =====
	async function openPosSections(item) {
		const response = await GET('/admin/pos-sections', { pos_id: item.id }, { loader: true })
		if (httpOk(response)) setSectionsModal({ show: true, posId: item.id, title: item.name, rows: response.data })
	}

	function toggleSection(list, id) {
		return list.map((r) => (r.id === id ? { ...r, checked: !r.checked } : r))
	}

	// Bo'limlarni menyu guruhlari bo'yicha sarlavhalab chizamiz (uzun tekis ro'yxatda odam adashmasin).
	// Guruhga tushmagan bo'limlar oxirida "Boshqa" ostida chiqadi — hech biri tushib qolmaydi.
	function renderGroupedRows(rows, onToggle) {
		const used = new Set()
		const row = (r) => (
			<label key={r.id} className="d-flex align-items-center gap-2 py-1" style={{ cursor: 'pointer' }}>
				<input type="checkbox" checked={!!r.checked} onChange={() => onToggle(r.id)} />
				<span>{r.label}</span>
				<span className="text-muted" style={{ fontSize: '11.5px' }}>{r.url}</span>
			</label>
		)
		const header = (text, muted) => (
			<div className={muted ? 'fw-bold text-muted mb-1' : 'fw-bold text-primary mb-1'}
				style={{ fontSize: '13px', borderBottom: '1px solid #eee', paddingBottom: '4px' }}>{text}</div>
		)
		const blocks = SECTION_GROUPS.map((g, gi) => {
			const groupRows = rows.filter((r) => g.perms.includes(r.name))
			if (!groupRows.length) return null
			groupRows.forEach((r) => used.add(r.id))
			return <div key={gi} className="mb-3">{header(t(g.i18n))}{groupRows.map(row)}</div>
		})
		const other = rows.filter((r) => !used.has(r.id))
		return (
			<>
				{blocks}
				{other.length > 0 &&
					<div className="mb-3">{header(t('other'), true)}{other.map(row)}</div>
				}
			</>
		)
	}

	async function savePosSections() {
		const ids = sectionsModal.rows.filter((r) => r.checked).map((r) => r.id)
		const response = await PUT('/admin/pos-sections', { pos_id: sectionsModal.posId, permission_ids: ids }, { loader: true })
		if (httpOk(response)) setSectionsModal({ show: false, posId: null, title: '', rows: [] })
	}

	// ===== Ustun qulflari (maxfiy ustunni yashirish) =====
	async function openPosColumnLocks(item) {
		const response = await GET('/admin/pos-column-locks', { pos_id: item.id }, { loader: true })
		if (httpOk(response)) {
			setColumnsModal({ show: true, posId: item.id, title: item.name, locked: response.data.locked || [] })
		}
	}

	function toggleColumnLock(key) {
		setColumnsModal((prev) => ({
			...prev,
			locked: prev.locked.includes(key) ? prev.locked.filter((k) => k !== key) : [...prev.locked, key],
		}))
	}

	async function savePosColumnLocks() {
		const response = await PUT('/admin/pos-column-locks',
			{ pos_id: columnsModal.posId, column_keys: columnsModal.locked }, { loader: true })
		if (httpOk(response)) setColumnsModal({ show: false, posId: null, title: '', locked: [] })
	}

	async function openTariffSections(tariffId) {
		const response = await GET('/admin/tariff-sections', { tariff_id: tariffId }, { loader: true })
		if (httpOk(response)) setTariffModal({ show: true, tariffId, rows: response.data })
	}

	async function saveTariffSections() {
		const ids = tariffModal.rows.filter((r) => r.checked).map((r) => r.id)
		const response = await PUT('/admin/tariff-sections', { tariff_id: tariffModal.tariffId, permission_ids: ids }, { loader: true })
		if (httpOk(response)) { setTariffModal({ show: false, tariffId: null, rows: [] }); getTariffPlans() }
	}

	async function getTariffPlans() {
		const response = await GET('/admin/tariff-plans')
		if (httpOk(response)) setTariffPlans(response.data)
	}

	async function changeTariffPlan(posId, planId) {
		const response = await PUT('/admin/pos/change-tariff-plan', { id: posId, tariff_plan_id: planId }, { loader: true })
		if (httpOk(response)) searchWithFilter()
	}

	// Tayyor sozlamalarni to'ldirish — MAVJUD tenantlar uchun (yangisida avtomat bo'ladi).
	// Nima qo'shilganini raqamlar bilan ko'rsatamiz; hech narsa qo'shilmasa ham xabar beramiz,
	// aks holda tugma «ishlamadi» deb tushuniladi.
	async function seedSettings(item) {
		const response = await POST('/admin/pos/seed-settings', { id: item.id }, { loader: true })
		if (httpOk(response)) {
			const added = response.data?.added ?? {}
			const total = Object.values(added).reduce((s, v) => s + Number(v || 0), 0)
			toast.success(total > 0
				? `${item.login}: ${total} ${t('seed_settings_added')}`
				: `${item.login}: ${t('seed_settings_already')}`)
			searchWithFilter()
		}
	}

	async function getPosPaymentTypes() {
		const response = await GET('/admin/helper/pos-payment-types')
		if (httpOk(response)) setPosPaymentTypes(response.data)
	}

	async function getUsers() {
		const response = await GET('/helper/users')
		if (httpOk(response)) setUsers(response.data)
	}

	useEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		getTariffPlans()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="vertical-center">
					<h4>
						{t('poses')} [{data.total}]
					</h4>
				</div>
				<div className="d-flex">
					<button className="btn-rounded btn btn-outline-primary me-2" id="tariff_plans_btn"
						onClick={() => openTariffSections(tariffPlans.length ? tariffPlans[0].id : null)}>
						{t('tariff_plans')}
					</button>
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModalCreateUpdate(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>
									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={statuses}
													value={statuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter(false)}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div className="d-flex gap-2">
								<div className="vertical-center">
									<span className="bg-primary bg-border text-white">
										<span>{t('active')}: {data?.status?.total_active}</span>
									</span>
								</div>
								<div className="vertical-center">
									<span className="bg-secondary bg-border text-white">
										<span>{t('disconnected')}: {data?.status?.total_not_active}</span>
									</span>
								</div>
								<div className="vertical-center">
									<span className="bg-danger bg-border text-white">
										<span>{t('deleted')}: {data?.status?.total_deleted}</span>
									</span>
								</div>
								{/* «Faol» = oxirgi 30 kunda chek yozgan. Yuqoridagi «Aktiv» esa
								    faqat status=1 — ikkalasi bir xil emas va farqi muhim. */}
								<div className="vertical-center">
									<span className="bg-success bg-border text-white">
										<span>{t('working_30d')}: {data?.status?.total_working}</span>
									</span>
								</div>
								{/* Muddati o'tganlar — faqat sana KIRITILGANLAR ichida sanaladi.
								    0 chiqishi "hamma to'lagan" degani emas: sana kiritilmagan
								    bo'lsa ham 0 chiqadi. Shuning uchun 0 da umuman ko'rsatilmaydi. */}
								{Number(data?.status?.total_expired) > 0 &&
									<div className="vertical-center">
										<span className="bg-danger bg-border text-white">
											<span>{t('expired')}: {data?.status?.total_expired}</span>
										</span>
									</div>
								}
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
								{filterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', filterData.status, 'name')}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'minWidth': '33px' }} className="text-center">ID</th>
									<th style={{ 'width': '10%' }}>{t('login')}</th>
									<th style={{ 'width': '22%' }}>{t('pos')}</th>
									<th style={{ 'minWidth': '105px' }}>{t('phone')}</th>
									<th style={{ 'width': '9%' }} className="text-end">{t('tariff')}</th>
									<th style={{ 'minWidth': '110px' }} className="text-center">{t('tariff_plan')}</th>
									<th style={{ 'width': '9%' }} className="text-end">{t('balance')}</th>
									<th style={{ 'minWidth': '88px' }} className="text-center">{t('last_payment')}</th>
									{/* «Sana» (ro'yxatdan o'tgan) o'rniga «Obuna boshlandi» —
									    dastlab ikkalasi bir xil qiymat edi, takror ustun keraksiz.
									    Obuna sanasi esa tahrirlanadi, ro'yxat sanasi esa yo'q. */}
									<th style={{ 'minWidth': '92px' }} className="text-center">{t('subscription_start')}</th>
									<th style={{ 'minWidth': '104px' }} className="text-center">{t('paid_until')}</th>
									<th style={{ 'minWidth': '88px' }} className="text-center td-ellipsis"
										title={t('last_cheque')}>
										{t('last_cheque')}
									</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('status')}</th>
									<th style={{ 'minWidth': '33px' }} className="text-end"></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="text-center"><b>{item.id}</b></td>
										<td>{item.login}</td>
										<td className="td-ellipsis" title={item.id}>{item.name}</td>
										<td>{item.phone}</td>
										<td className="text-end">{formatMoney(item.tariff)}</td>
										<td className="text-center" onClick={(e) => e.stopPropagation()}>
											<select className="form-select form-select-sm" value={item.tariff_plan_id || ''}
												onChange={(e) => changeTariffPlan(item.id, e.target.value)}>
												<option value="" disabled>—</option>
												{tariffPlans.map((p) => (
													<option key={p.id} value={p.id}>{p.name} ({p.sections})</option>
												))}
											</select>
										</td>
										<td className="text-end">{formatMoney(item.balance)}</td>
										{/* Bo'sh joy "—" bo'lib ko'rinsin — ma'lumot yo'qolgandek
										    tuyulmasin: ko'p tenant hech qachon to'lov kiritmagan. */}
										<td className="text-center">
											{item.last_payment_date
												? formatDate(item.last_payment_date)
												: <span className="text-muted">—</span>}
										</td>
										<td className="text-center">
											{item.subscription_start_at
												? formatDate(item.subscription_start_at)
												: <span className="text-muted">—</span>}
										</td>
										{/* Muddat. `days_left` NULL bo'lsa — sana kiritilmagan, ya'ni
										    "0 kun qoldi" DEB KO'RSATMASLIK kerak: bilmaslik va
										    muddati o'tgan — bu ikki boshqa holat. */}
										<td className="text-center">
											{item.paid_until_at
												? <>
													{formatDate(item.paid_until_at)}
													<br />
													<small className={Number(item.days_left) < 0 ? 'text-danger' : 'text-success'}>
														{Number(item.days_left) < 0
															? `${Math.abs(Number(item.days_left))} ${t('days_overdue')}`
															: `${item.days_left} ${t('days_remaining')}`}
													</small>
												</>
												: <span className="text-muted">—</span>}
										</td>
										<td className="text-center">
											{item.last_cheque_date
												? formatDate(item.last_cheque_date)
												: <span className="text-muted">—</span>}
										</td>
										<td className={`text-center text-white cursor ${returnClassStatus(item.status)}`}
											onClick={() => toggleModalStatus(true, item)}>
											{item.status === 1 &&
												<span>{t('activated')}</span>
											}
											{item.status === -1 &&
												<span>{t('disconnected')}</span>
											}
											{item.status === -2 &&
												<span>{t('frozen')}</span>
											}
											{item.status === -3 &&
												<span>{t('deleted')}</span>
											}
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModalUpdate(item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														<div className="table-dropdown-item"
															onClick={() => openPosSections(item)}>
															<i className="uil-check-square"></i>
															{t('sections')}
														</div>
														<div className="table-dropdown-item"
															onClick={() => openPosColumnLocks(item)}>
															<i className="uil-eye-slash"></i>
															{t('column_locks')}
														</div>
														{/* Tayyor sozlamalar: yangi tenantda avtomat qo'shiladi, bu tugma
														    ILGARI ochilgan tenantlar uchun. Idempotent — faqat yo'q narsani
														    qo'shadi, mavjud sozlamaga tegmaydi. */}
														<div className="table-dropdown-item"
															onClick={() => seedSettings(item)}>
															<i className="uil-magic"></i>
															{t('seed_settings')}
														</div>
														<div className="table-dropdown-item"
															onClick={() => toggleModalPayment(item)}>
															<i className="uil-edit-alt"></i>
															Оплата
														</div>
														<div className="table-dropdown-item"
															onClick={() => toggleModalInfo(item)}>
															<i className="uil-info-circle"></i>
															История оплат
														</div>
														<div className="table-dropdown-item"
															onClick={() => toggleModalInvoice(item)}>
															<i className="uil-arrow-right"></i>
															Выставить счет
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div >

			{/* MODAL UPDATE*/}
			<Modal Modal show={modalUpdate} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => setModalUpdate(false)
				}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<span>Создать</span>
							:
							<span>Редактировать</span>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						<div className="form-group">
							<label>Логин</label>
							<input type="text" className="form-control" name="login"
								disabled={selectedItem.id}
								value={selectedItem?.login?.replace(/\s+/g, '').toLowerCase()}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'login': e.target.value })} />
						</div>
						{/* Parol FAQAT yangi tenant yaratishda. Tahrirlashda bu maydon
						    ilgari ham ko'rinardi, lekin `update()` uni umuman saqlamasdi:
						    admin yangi parol yozib "Saqlash" bosardi, 200 OK kelardi va
						    mijozga ISHLAMAYDIGAN parol aytilardi. Yashirilgani — chin
						    holatni ko'rsatgani uchun; haqiqiy parol tiklash alohida ish. */}
						{!selectedItem.id &&
							<div className="form-group">
								<label>Пароль</label>
								<input type="text" className="form-control" name="password" value={selectedItem.password}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'password': e.target.value })} />
							</div>
						}
						<div className="form-group">
							<label>Телефон</label>
							<input type="text" className="form-control" name="phone" value={selectedItem.phone}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'phone': e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>
						<div className="form-group">
							<label>Название</label>
							<input type="text" className="form-control" name="name" value={selectedItem.name}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>
						<div className="form-group">
							<label>Тариф</label>
							<input type="text" className="form-control" name="tariff"
								value={formatMoneyInput(selectedItem.tariff) ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'tariff': e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>

						{/* Obuna sanalari (2026-08-05) — FAQAT qo'lda kiritiladi.
						    Avtomatik uzaytirish yoki pul yechish YO'Q: super-admin
						    to'lovni olgach sanani o'zi ko'chiradi. */}
						{selectedItem.id &&
							<div className="row">
								<div className="col-md-6">
									<div className="form-group">
										<label>{t('subscription_start')}</label>
										{/* `slice(0,10)` — baza `date` qaytaradi, lekin vaqt qo'shilib
										    kelsa <input type="date"> qiymatni umuman ko'rsatmaydi. */}
										<input type="date" className="form-control" name="subscription_start_at"
											value={(selectedItem.subscription_start_at || '').slice(0, 10)}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'subscription_start_at': e.target.value })} />
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-group">
										<label>{t('paid_until')}</label>
										<input type="date" className="form-control" name="paid_until_at"
											value={(selectedItem.paid_until_at || '').slice(0, 10)}
											onChange={(e) => setSelectedItem({ ...selectedItem, 'paid_until_at': e.target.value })} />
										<small className="text-muted">{t('paid_until_hint')}</small>
									</div>
								</div>
							</div>
						}

						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setModalUpdate(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal >
			{/* MODAL UPDATE*/}

			{/* MODAL PAYMENT*/}
			<Modal show={modalPayment} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => setModalPayment(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Оплата</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => payment(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('type')}</label>
							<Select
								isClearable
								options={paymentStatuses}
								value={paymentStatuses.find(option => option.id === selectedItem.status) || ''}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'status': option ? option.id : null })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						{selectedItem.status === 1 &&
							<div className="form-group">
								<label>Тип оплаты</label>
								<Select
									isClearable
									options={posPaymentTypes}
									value={posPaymentTypes.find(option => option.id === selectedItem.pos_payment_type_id) || ''}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'pos_payment_type_id': option ? option.id : null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						}
						<div className="form-group">
							<label>Сумма</label>
							<input type="text" className="form-control" name="amount"
								value={selectedItem.amount ? formatMoneyInput(selectedItem.amount) : ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9.-]/g, '') })} />
						</div>
						<div className="form-group">
							<label>Примечание</label>
							<input type="text" className="form-control" name="note" value={selectedItem.note}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => setSelectedItem(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT*/}

			{/* MODAL INVOICE*/}
			<Modal show={modalInvoice} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => setModalInvoice(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Выставить счет</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createInvoice(e)} autoComplete="off">
						<div className="form-group">
							<label>Сумма</label>
							<input type="text" className="form-control" name="amount"
								value={selectedItem.amount ? formatMoneyInput(selectedItem.amount) : ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9]/g, '') })} />
						</div>
						<div className="input-group mb-2">
							<span className="input-group-text">998</span>
							<input type="number" className="form-control"
								name="invoice_phone"
								placeholder={t('phone')}
								value={selectedItem.invoice_phone ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'invoice_phone': e.target.value.replace(/[^0-9]/g, '') })}
							/>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setSelectedItem(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL INVOICE*/}

			{/* MODAL CHANGE STATUS*/}
			<Modal show={modalStatus} animation={false} centered size="sm"
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => toggleModalStatus(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Статус</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => handleChangeStatus(e)} autoComplete="off">
						<div className="d-flex flex-column gap-3">
							<div className="form-check">
								<input id="status1" className="form-check-input" type="radio" name="status"
									checked={selectedItem.status === 1 ? true : false}
									onChange={(e) => {
										if (e.target.checked) {
											setSelectedItem({ ...selectedItem, 'status': 1 })
										}
									}}
								/>
								<label className="form-check-label" htmlFor="status1">
									Активировать
								</label>
							</div>
							<div className="form-check">
								<input id="status-1" className="form-check-input" type="radio" name="status"
									checked={selectedItem.status === -1 ? true : false}
									onChange={(e) => {
										if (e.target.checked) {
											setSelectedItem({ ...selectedItem, 'status': -1 })
										}
									}}
								/>
								<label className="form-check-label" htmlFor="status-1">
									Заблокирован за неуплату
								</label>
							</div>
							<div className="form-check">
								<input id="status-2" className="form-check-input" type="radio" name="status"
									checked={selectedItem.status === -2 ? true : false}
									onChange={(e) => {
										if (e.target.checked) {
											setSelectedItem({ ...selectedItem, 'status': -2 })
										}
									}}
								/>
								<label className="form-check-label" htmlFor="status-2">
									Замороженный
								</label>
							</div>
							<div className="form-check">
								<input id="status-3" className="form-check-input" type="radio" name="status"
									checked={selectedItem.status === -3 ? true : false}
									onChange={(e) => {
										if (e.target.checked) {
											setSelectedItem({ ...selectedItem, 'status': -3 })
										}
									}}
								/>
								<label className="form-check-label" htmlFor="status-3">
									Удален
								</label>
							</div>
						</div>

						<div className="d-flex w-100 mt-3">
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CHANGE STATUS*/}

			{/* MODAL PAYMENT HISTORY*/}
			<Modal show={modalInfo} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => setModalInfo(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						История
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th className="text-nowrap">{t('date')}</th>
									<th className="text-nowrap">{t('note')}</th>
									<th className="text-nowrap text-center">{t('status')}</th>
									<th className="text-nowrap text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{payments?.map((item, index) => (
									<tr key={index}>
										<td>{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
										<td className="td-ellipsis" title={item.note}>{item.note}</td>
										<td className="text-center">
											{item.status === 1 &&
												<span className="text-success">Успешно</span>
											}
											{item.status === -2 &&
												<span className="text-danger">Списание</span>
											}
											{item.status === -3 &&
												<span className="text-danger">Перевод</span>
											}
										</td>
										<td className="text-nowrap text-end">{formatMoney(item.amount)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT HISTORY*/}
			{/* MODAL: BIZNES BO'LIMLARI */}
			<Modal show={sectionsModal.show} animation={false} centered size="lg"
				onHide={() => setSectionsModal({ show: false, posId: null, title: '', rows: [] })}>
				<Modal.Header closeButton>
					<Modal.Title>{t('sections')} — {sectionsModal.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ maxHeight: '65vh', overflowY: 'auto' }}>
					<p className="text-muted" style={{ fontSize: '13px' }}>{t('sections_hint')}</p>
					{renderGroupedRows(sectionsModal.rows,
						(id) => setSectionsModal({ ...sectionsModal, rows: toggleSection(sectionsModal.rows, id) }))}
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-warning" onClick={() => setSectionsModal({ show: false, posId: null, title: '', rows: [] })}>{t('cancel')}</button>
					<button className="btn btn-primary" onClick={() => savePosSections()}>{t('save')}</button>
				</Modal.Footer>
			</Modal>

			{/* MODAL: USTUN QULFLARI */}
			<Modal show={columnsModal.show} animation={false} centered size="lg"
				onHide={() => setColumnsModal({ show: false, posId: null, title: '', locked: [] })}>
				<Modal.Header closeButton>
					<Modal.Title>{t('column_locks')} — {columnsModal.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ maxHeight: '65vh', overflowY: 'auto' }}>
					<p className="text-muted" style={{ fontSize: '13px' }}>{t('column_locks_hint')}</p>
					{COLUMN_LOCK_CATALOG.map((sec) => (
						<div key={sec.section} className="mb-3">
							<div className="fw-bold mb-1">{t(sec.sectionLabel)}</div>
							{sec.columns.map((c) => (
								<label key={c.key} className="d-flex align-items-center gap-2 py-1" style={{ cursor: 'pointer' }}>
									<input type="checkbox" checked={columnsModal.locked.includes(c.key)}
										onChange={() => toggleColumnLock(c.key)} />
									<span>{t(c.label)}</span>
								</label>
							))}
						</div>
					))}
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-warning" onClick={() => setColumnsModal({ show: false, posId: null, title: '', locked: [] })}>{t('cancel')}</button>
					<button className="btn btn-primary" onClick={() => savePosColumnLocks()}>{t('save')}</button>
				</Modal.Footer>
			</Modal>

			{/* MODAL: TARIF BO'LIMLARI */}
			<Modal show={tariffModal.show} animation={false} centered size="lg"
				onHide={() => setTariffModal({ show: false, tariffId: null, rows: [] })}>
				<Modal.Header closeButton>
					<Modal.Title>{t('tariff_plans')}</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ maxHeight: '65vh', overflowY: 'auto' }}>
					<div className="d-flex gap-2 mb-3 flex-wrap">
						{tariffPlans.map((p) => (
							<button key={p.id} className={'btn btn-sm ' + (tariffModal.tariffId === p.id ? 'btn-primary' : 'btn-outline-primary')}
								onClick={() => openTariffSections(p.id)}>{p.name} ({p.sections})</button>
						))}
					</div>
					{renderGroupedRows(tariffModal.rows,
						(id) => setTariffModal({ ...tariffModal, rows: toggleSection(tariffModal.rows, id) }))}
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-warning" onClick={() => setTariffModal({ show: false, tariffId: null, rows: [] })}>{t('cancel')}</button>
					<button className="btn btn-primary" onClick={() => saveTariffSections()}>{t('save')}</button>
				</Modal.Footer>
			</Modal>

		</>
	)
}

export default Index